import { rpc } from './rpc';

export interface LoginParams {
  email: string;
  senha: string;
}
export interface LoginData {
  accessToken: string;
}
export const callLogin = async (params: LoginParams) =>
  rpc<LoginParams, LoginData>('login_teclado', params);
